import { Suspense } from "solid-js";

import { Loading } from "@/components/Base/Loading/Loading";
import { type RouteSectionProps } from "@solidjs/router";

export function H5SubLayout(props: RouteSectionProps) {
  let scrollContainer!: HTMLDivElement;
  return (
    <div class="min-h-screen" ref={scrollContainer}>
      <Suspense
        fallback={
          <div class="flex h-screen w-full items-center justify-center">
            <Loading />
          </div>
        }
      >
        {props.children}
      </Suspense>
    </div>
  );
}
